import { StyleSheet, Dimensions } from 'react-native';

const { width: screenWidth } = Dimensions.get('window');
const baseInputStyle = {
  height: 40,
  width: '90%',
  alignSelf: 'center',
  marginTop: 50,
};
const halfInputStyle = {
  height: 40,
  width: screenWidth * 0.4,
  marginTop: 50,
};
export default StyleSheet.create({
  cardNoInput: {
    ...baseInputStyle,
    marginTop: 30,
  },
  nameOnCardInput: {
    ...baseInputStyle,
  },
  expiryDate: {
    ...halfInputStyle,
    left: 20,
  },
  cvvInput: {
    ...halfInputStyle,
    right: 20,
  },
  cardNameInput: {
    ...baseInputStyle,
    marginVertical: 50,
  },
  secureIcon: {
    left: 20,
  },
  secureDescription: {
    marginVertical: 5,
    alignSelf: 'flex-end',
    right: 20,
  },
});
